import { render, staticRenderFns } from "./ContestHomeworkEdit.vue?vue&type=template&id=66244d02&scoped=true&"
import script from "./ContestHomeworkEdit.vue?vue&type=script&lang=js&"
export * from "./ContestHomeworkEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContestHomeworkEdit.vue?vue&type=style&index=0&id=66244d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66244d02",
  null
  
)

export default component.exports